module.exports = __webpack_public_path__ + "img/Uber@3x.0a89b037.png";